<section class="testimonial-area bg-img mt-120 mt-md-80 mt-sm-60"
        data-bg="assets/img/testimonial/home2-testi-bg.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-9 m-auto">
                    <div class="testimonial-content-wrap">
                        <div class="ht-slick-slider-wrapper">
                            <div class="ht-slick-slider"
                                data-slick='{"slidesToShow": 1, "arrows": true, "prevArrow": ".prev-arrow", "nextArrow": ".next-arrow"}'>
                                <!-- Single Testimonial Start -->
                                <div class="single-testimonial-wrap layout--2">
                                    <figure class="author-thumb"><img src="assets/assets/img/testimonial/testimonial-1.jpg"
                                            alt="Testimonial"></figure>
                                    <p><sup class="quote-icon">“</sup>This is absolutely the best theme I have ever
                                        used. The design quality is exquisite. Their response time is unheard of.</p>
                                    <h3 class="client-name">Jessica Jung <span class="client-designation">Graphic
                                            Design</span></h3>
                                </div><!-- Single Testimonial End -->
                                <!-- Single Testimonial Start -->
                                <div class="single-testimonial-wrap layout--2">
                                    <figure class="author-thumb"><img src="assets/assets/img/testimonial/testimonial-2.jpg"
                                            alt="Testimonial"></figure>
                                    <p><sup class="quote-icon">“</sup>This is absolutely the best theme I have ever
                                        used. The design quality is exquisite. Their response time is unheard of.”</p>
                                    <h3 class="client-name">Ken Wheeler <span class="client-designation">JavaScript
                                            Dev</span></h3>
                                </div><!-- Single Testimonial End -->
                                <!-- Single Testimonial Start -->
                                <div class="single-testimonial-wrap layout--2">
                                    <figure class="author-thumb"><img src="assets/assets/img/testimonial/testimonial-3.jpg"
                                            alt="Testimonial"></figure>
                                    <p><sup class="quote-icon">“</sup>This is absolutely the best theme I have ever
                                        used. The design quality is exquisite. Their response time is unheard of.”</p>
                                    <h3 class="client-name">Sokina Begum <span class="client-designation">Front
                                            End</span></h3>
                                </div><!-- Single Testimonial End -->
                            </div><!-- Start Testimonial Slick Slider Nav -->
                            <div class="ht-slick-nav"><button class="prev-arrow"><i
                                        class="tri-o-prev-arrow"></i></button> <button class="next-arrow"><i
                                        class="tri-o-next-arrow"></i></button></div>
                            <!-- End Testimonial Slick Slider Nav -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
